<template>
  <footer class="p-3">
    <hr class="mb-4" />
    &copy; 2015 - {{ new Date().getFullYear() }} Beck24.com Wilfried Beck
  </footer>
</template>
